import {
  isLessonContentShown,
  isQuestionSectionShown,
  type ChapterReader,
} from '@/features/content/chapterVisibility';
import type { ComponentPageData } from '@/features/content/useComponent';
import { getDisplayedQuestions } from '@/features/questions/displayedQuestions';

import { collectPdfVideoLinks } from './videoUrlUtils';

/**
 * What an export of this chapter may hold: what its reader's page shows. The
 * dialog offers from this and the print page prints from it, so the two cannot
 * disagree. This is not access control: the browser already has all of it.
 */
export function getPrintableChapter(component: ComponentPageData, reader: ChapterReader) {
  const lessonContentShown = isLessonContentShown(reader);

  return {
    contentSections: lessonContentShown ? component.sections : [],
    questionSections: component.questionSections.filter((section) => {
      if (!isQuestionSectionShown(section.kind, reader)) {
        return false;
      }

      const { assigned, practice } = getDisplayedQuestions(section.questions, section.kind);

      return assigned.length > 0 || practice.length > 0;
    }),
    videoLinks: lessonContentShown ? collectPdfVideoLinks(component) : [],
  };
}

export type PrintableChapter = ReturnType<typeof getPrintableChapter>;
